import React, { useEffect, useRef } from 'react';
import { personal } from '../data';

export default function Hero() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;
    let particles = [];

    function resize() {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    }

    function mkParticle() {
      return {
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: 80 + Math.random() * 200,
        vx: (Math.random() - 0.5) * 0.15,
        vy: (Math.random() - 0.5) * 0.08,
        alpha: 0.018 + Math.random() * 0.025,
        hue: Math.random() > 0.6 ? [174, 200, 220][Math.floor(Math.random() * 3)] : 0,
        sat: Math.random() > 0.6 ? '15%' : '0%',
      };
    }

    function init() {
      resize();
      particles = Array.from({ length: 18 }, mkParticle);
    }

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (const p of particles) {
        const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
        const col = p.hue ? `hsla(${p.hue},${p.sat},75%,` : 'rgba(180,175,165,';
        g.addColorStop(0, col + p.alpha + ')');
        g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        p.x += p.vx; p.y += p.vy;
        if (p.x < -p.r) p.x = canvas.width + p.r;
        if (p.x > canvas.width + p.r) p.x = -p.r;
        if (p.y < -p.r) p.y = canvas.height + p.r;
        if (p.y > canvas.height + p.r) p.y = -p.r;
      }
      animId = requestAnimationFrame(draw);
    }

    init();
    draw();
    window.addEventListener('resize', resize);
    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <section id="hero" style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '2rem 2.5rem 5rem',
        position: 'relative',
        overflow: 'hidden',
        fontFamily: "'DM Mono', monospace",
        margin: 0,
    }}>
      <canvas ref={canvasRef} style={{
        position: 'absolute', inset: 0,
        width: '100%', height: '100%',
        pointerEvents: 'none',
      }} />

      {personal.available && (
        <p style={{
          fontSize: '11px', letterSpacing: '0.2em',
          textTransform: 'uppercase', color: '#9b9991',
          marginBottom: '1.2rem', position: 'relative',
        }}>
          Software Engineer — Available for work
        </p>
      )}

      <h1 style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontWeight: 300,
        fontSize: 'clamp(52px, 8vw, 96px)',
        lineHeight: 1.0, letterSpacing: '-0.01em',
        color: '#2e2d2a', position: 'relative',
      }}>
        {personal.namePlain}<br />
        <em style={{ fontStyle: 'italic', color: '#3d6e78' }}>{personal.nameItalic}</em>
      </h1>

      <p style={{
        marginTop: '1.5rem', fontSize: '13px',
        color: '#6b6963', letterSpacing: '0.06em',
        maxWidth: '380px', lineHeight: 1.8,
        position: 'relative',
      }}>
        {personal.tagline}
      </p>

      <div style={{
        position: 'absolute', bottom: '2rem', right: '2.5rem',
        fontSize: '10px', letterSpacing: '0.18em',
        textTransform: 'uppercase', color: '#9b9991',
        writingMode: 'vertical-rl',
        display: 'flex', alignItems: 'center', gap: '10px',
      }}>
        <span style={{
          display: 'block', width: '0.5px', height: '40px',
          background: '#cccac3',
          animation: 'scrollLine 2s ease-in-out infinite',
        }} />
        Scroll
      </div>

      <style>{`
        @keyframes scrollLine {
          0%, 100% { transform: scaleY(1); opacity: 0.4; }
          50% { transform: scaleY(0.5); opacity: 1; }
        }
      `}</style>
    </section>
  );
}
